import { AccountPlan } from '@/constants/enum';
import { usePlanDisplayName } from '@/hooks/usePlanDisplayName';
import { useUpgradeTracking } from '@/hooks/useUpgradeTracking';
import { BannerProps } from '@shopify/polaris';
import { memo } from 'react';
import CustomBanner from '../CustomBanner';

interface UpgradeBannerProps extends BannerProps {
  isOpen?: boolean;
  usedFeature: AccountPlan;
  isHiddenTitle?: boolean;
  feature: string;
}

const UpgradeBanner = ({ isOpen = true, usedFeature, isHiddenTitle = false, feature, ...props }: UpgradeBannerProps) => {
  const { navigateToPlan } = useUpgradeTracking();
  const { getPlanName } = usePlanDisplayName();

  const handleUpgradeNow = () => {
    navigateToPlan({
      trigger_type: 'feature_gate',
      trigger_element: 'Upgrade Now',
      feature,
    });
  };

  return (
    <CustomBanner
      isClose={!isOpen}
      maxHeight="15rem"
      tone="warning"
      title={isHiddenTitle ? '' : 'Upgrade to use this feature'}
      action={{
        content: 'Upgrade Now',
        onAction: handleUpgradeNow,
      }}
      {...props}
    >
      This feature is only <strong>available</strong> on the paid plan. You need to <strong>upgrade</strong> to the{' '}
      <strong>{getPlanName(usedFeature)} or higher plan</strong> to use this feature.
    </CustomBanner>
  );
};

export default memo(UpgradeBanner);
